import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import classNames from 'classnames';
import Typography from '../../Generic/Typography';
import socialShareTwStyles from './socialShare-tw-styles';
import { Button } from '../../Generic/Button';
import path from '../../../assets/images/svgImages.svg';

const spritePath = typeof path === 'string' ? path : path?.src || '';

class CopyLink extends Component {
  state = {
    copied: false,
  };

  render() {
    const { copied } = this.state;
    const { locale } = this.props;
    if (typeof window === 'undefined') return null;
    const urlLink = window.location.href;
    const constants = require(`../../../constants/messages/${locale}`);
    return (
      <div className={classNames(socialShareTwStyles.copyDialog.wrapper)}>
        <CopyToClipboard
          text={urlLink}
          onCopy={() => {
            this.setState({ copied: true });
          }}
        >
          <Button
            className={classNames(
              'share-btn sm:flex sm:flex-col-reverse items-center px-15'
            )}
          >
            <Typography
              component="span"
              className={classNames(socialShareTwStyles.appText)}
            >
              {`Copy`}
            </Typography>
            <div className={classNames(socialShareTwStyles.imageWrappingDiv)}>
              <svg
                className={classNames(
                  socialShareTwStyles.iconStyles,
                  'w-15 h-15'
                )}
              >
                <use xlinkHref={`${spritePath}#Copy`} />
              </svg>
            </div>
          </Button>
        </CopyToClipboard>

        <span
          className={classNames(
            socialShareTwStyles.copied,
            copied ? 'copyShow' : 'copyHide'
          )}
        >
          {constants.copiedClipboard}
        </span>
      </div>
    );
  }
}
CopyLink.propTypes = {
  locale: PropTypes.string,
};

CopyLink.defaultProps = {
  locale: 'pt-BR',
};
export default CopyLink;
